import Responsive from "react-responsive";

export const Desktop = (props: any) => <Responsive {...props} minWidth={992} />;
export const Mobile = (props: any) => <Responsive {...props} maxWidth={767} />;
